import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Paper, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #f5f5f5;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
`;

const MessageWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  gap: 4px;
  width: 100%;
`;

const Message = styled(Paper)`
  padding: 10px 16px;
  max-width: 80%;
  border-radius: ${props => props.isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px'};
  background-color: ${props => props.isUser ? '#2e3092' : '#ffffff'};
  color: ${props => props.isUser ? '#ffffff' : '#000000'};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: ${props => props.isUser ? 'none' : '1px solid #e0e0e0'};
`;

const Timestamp = styled(Typography)`
  font-size: 11px;
  color: #666;
  margin: 0 8px;
`;

const ChatMessages = ({ messages }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <MessagesContainer>
      {messages.map((message, index) => (
        <MessageWrapper
          key={index}
          isUser={message.isUser}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <Message isUser={message.isUser} elevation={0}>
            <Typography variant="body2">{message.text}</Typography>
          </Message>
          <Timestamp variant="caption">
            {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </Timestamp>
        </MessageWrapper>
      ))}
      <div ref={messagesEndRef} />
    </MessagesContainer>
  );
};

export default ChatMessages; 